import { Part, PART_INITIAL_VALUES } from "./Part";

export interface Carrier extends Part {
	CarrierStatusCode: string;
	IsActive: boolean | null;
}

export const CARRIER_INITIAL_VALUES: Carrier = {
	...PART_INITIAL_VALUES,
	CarrierStatusCode: "E",
	IsActive: true,
};
